var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ServiceBase, ServiceEndPoints } from "@/modules/services/models/ServiceBase";
import { User } from "../models/User";
var UserServices = (function (_super) {
    __extends(UserServices, _super);
    function UserServices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserServices.prototype.updateUser = function (user) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'UpdateCandidate', user.getData({ tags: ['update'] }));
    };
    UserServices.prototype.changeUserPassword = function (newPassword) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'ChangeCandidatePassword', {
            NewPassword: newPassword
        });
    };
    UserServices.prototype.changeUserEmail = function (oldEmail, newEmail) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'UpdateCandidateEmail', {
            NewEmail: newEmail,
            OldEmail: oldEmail
        });
    };
    UserServices.prototype.updateUserPicture = function (userId, pictureFilePath) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'SaveCandidateImage', {
            UserId: userId,
            filePath: pictureFilePath
        });
    };
    UserServices.prototype.deleteUser = function (userId) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'DeleteCandidate', {
            Option: 1
        });
    };
    UserServices.prototype.undeleteUser = function (userId) {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'DeleteCandidate', {
            Option: 0
        });
    };
    UserServices.prototype.getUser = function () {
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + "GetCandidate", {}, undefined, new User());
    };
    UserServices.prototype.getPublicUser = function () {
        var publicUrl = decodeURIComponent(window.location.search.substring(1));
        console.log('getPublicUser', window.location, publicUrl);
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + 'GetCandidateByPublicUrl', {
            PublicUrl: publicUrl
        }, null, new User());
    };
    UserServices.prototype.logUserOut = function (token) {
        if (!token)
            token = this.userToken;
        return this.postData(ServiceEndPoints.ACADEMIC_SERVICES + "Logout", {
            Token: token
        });
    };
    return UserServices;
}(ServiceBase));
export { UserServices };
export var userServices = new UserServices();



//////////////////
// WEBPACK FOOTER
// ./src/modules/users/services/UserServices.ts
// module id = Nksp
// module chunks = 10